import axios from "../axios";
class OrgService {
  static Instance() {
    return new OrgService();
  }

  getAllOrg(request) {
    return axios.post("/api/org/list/all", request);
  }

  getClientOrgDetails() {
    return axios.get("/api/org/details");
  }

  getAllSupplier(request) {
    return axios.post("/api/org/supplier", request);
  }

  createOrgSupplier(request) {
    return axios.post("/api/org/", request);
  }

  deleteOrgSupplier(orgId) {
    return axios.post(`/api/org/delete/orgSupplier?orgId=${orgId}`);
  }

  updateOrgSupplier(request) {
    return axios.post("/api/org/update", request);
  }

  fetchSupplierDetails(orgId) {
    return axios.get(`/api/org/enquiry?orgId=${orgId}`);
  }

  exportToExcel(request) {
    return axios.post("/api/org/list/export", request, {
      responseType: "blob",
    });
  }

  downloadImportTemplate() {
    return axios.get(`/api/org/import/format/generate?type=supplier`, {
      //todo remove later
      responseType: "blob",
    });
  }

  uploadOrgData(formData) {
    return axios.post("/api/org/import", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  getAllClientOrgsDropDown() {
    return axios.get('/api/org/client/list/all');
  }

  getAllSupplierOrgsDropDown() {
    return axios.get('/api/org/supplier/list/all');
  }

  getClientOrgsDropDown(orgName = '') {
    return axios.get(`/api/org/client/list${orgName ? `?orgName=${encodeURIComponent(orgName)}` : ''}`);
  }

  getSupplierDropDown(orgName = '') {
    return axios.get(`/api/org/supplier/list${orgName ? `?orgName=${encodeURIComponent(orgName)}` : ''}`);
  }

  getAllOrgsToSwitch() {
    return axios.get('/api/org/switch/dropdown');
  }

  switchPrimaryOrg(newOrgId) {
    return axios.post(`/api/org/switch/primaryOrg?newOrgId=${newOrgId}`);
  }

}
export default OrgService.Instance();
